import { Text as BaseText } from '@qga/roo-ui/components';
import styled from '@emotion/styled';

const Text = styled(BaseText)`
  text-transform: uppercase;
`;

const BreakdownHeading = (props) => <Text as="div" fontSize="sm" color="greys.steel" lineHeight="tight" px={5} pb={2} {...props} />;

BreakdownHeading.displayName = 'BreakdownHeading';

export default BreakdownHeading;
